
import CustomModal from './../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../components/CustomTextField';
import CustomRadio from './../../../components/CustomRadio';
import FunctionalityAddDashboard from './../Functionality/AddDashboard';
import { templateIdToComponent } from '../Model/Templates';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AddDashboardModal = ({ show, onHide, templates }) => {

    const {
        handleCreate,
        t,
        dashboardName,
        showError,
        setDashboardName,
        selectedTemplate,
        handleRadioChange
    } = FunctionalityAddDashboard({onHide});


    return (
        <CustomModal
            title='create'
            size='lg'
            onHide={onHide}
            onConfirm={handleCreate}
            buttonConfirm='confirm'
            buttonCancelText='cancel'
            cancelButton
            confirmButton
            closeButton
            show={show}
            classNameBody="pt-2"
        >
            <h5 className='label-graph-top mb-2'>{t('enterDashboardName')}</h5>
            <div className='mb-3'>
                <CustomTextField
                    id='txt_adm_dashboard_name'
                    value={dashboardName}
                    trans='dashboard_name'
                    isValid={!showError || !!dashboardName}
                    onChange={(e) => {
                        setDashboardName(e.target.value);
                    }}
                    helperText={showError && !dashboardName ? t('requiredField') : ''}
                    length={60}
                    required={true}
                />
            </div>

            <h5 className='label-graph mt-4 mb-2'>{t('followTemplate')}</h5>
            {showError && <p className='fs-span font-color-error-600'>{t('requiredField')}</p>}

            <div className='d-flex flex-wrap justify-content-center'>
                {Object.keys(templateIdToComponent).map((id) => (
                    <div className='col-12 col-sm-12 col-md-4 mb-4 d-flex justify-content-center' key={id}>
                        <div className='radioC text-center'>
                            <CustomRadio
                                id='rbtn_adm_template_selection'
                                name='template-selection'
                                value={id}
                                checked={selectedTemplate === id}
                                onChange={handleRadioChange}
                                required={true}

                            />
                            <div className='mt-2'>{templateIdToComponent[id]}</div>
                        </div>
                    </div>
                ))}
            </div>
        </CustomModal>
    );
};

export default AddDashboardModal;
